<form [formGroup]="formGroup" novalidate>
    <div
        [uploaderKey]="uploaderKey"
        [blobType]="blobType"
        [pathToAppend]="pathToAppend"
        [supportedFileTypes]="supportedImageTypes"
        [maxInputSizeInBytes]="maxFileSizeInBytes"
        (onUploadStarted)="onUploadStarted()"
        (onUploadCompleted)="onUploadCompleted($event)"
        caApeerFileUpload
        [errorNotificationMode]="errorNotificationMode"
        data-uit="file-upload"
    >
        <button type="button" class="btn btn-blk w-100 my-4" [disabled]="isUploading || fileUrls.length > 0" (click)="uploadSection.click()">
            <ca-icon name="upload" size="l"></ca-icon>{{ buttonText }}
            <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [accept]="accept" [uploader]="uploader" [multiple]="multiple" hidden />
        </button>
    </div>

    <div class="my-2">
        <ca-file-upload-progress
            *ngIf="uploader?.queue?.length > 0"
            [file]="uploader?.queue[0]"
            [uploadProgress]="uploader?.queue[0]?.progress"
        ></ca-file-upload-progress>

        <ng-container *ngFor="let formControl of fileUrls.controls; let i = index">
            <div *ngIf="formControl" class="exist-item" #fileItem>
                <span class="file-name">{{ formControl.value }}</span>
                <button type="button" class="btn ca-btn-icon ca-btn-icon-small" (click)="removeFileItem(fileItem, i)">
                    <ca-icon name="cross" size="xl"></ca-icon>
                </button>
            </div>
        </ng-container>
    </div>
</form>
